import UserSkill from "./model"
import Collection from "../../../../../core/data-structures/collection"

export default class UserSkillsCollection extends Collection<UserSkill> {

    constructor(models: any) {
        super(models)
    }

    static initFromJson(data:JSONArray):UserSkillsCollection {
        const collection = new UserSkillsCollection([])

        _.map(data, (record:JSONObject)=>{
            collection.add(new UserSkill(record))
        })

        return collection
    }

    toSaveJSON() {return this.toJSON()}
}
